module.exports = __webpack_public_path__ + "img/DE00285.14f706a8.png";